/*
 * timeline.js — полоса времени /video-stabilizer: график тряски по кадрам и
 * указатель воспроизведения, по которому перематывают.
 *
 * Заливка — тряска ИСХОДНИКА (сила рывка кадра, VideoStabilizer.profile),
 * линия — то, что останется после; во время разбора график растёт по мере
 * того, как пул воркеров отдаёт пары. Так человек видит, ГДЕ ролик трясёт, и
 * одним касанием попадает в худшее место — у профессиональных программ это
 * график анализа (Resolve, Gyroflow), у онлайн-стабилизаторов его нет вовсе.
 *
 *   var tl = VSTimeline.create({ el, canvas, onSeek(frac) });
 *   tl.setData({ total, before, after })   — массивы по кадрам (null — ещё нет)
 *   tl.setProgress(frac | null)            — докуда дошёл разбор
 *   tl.setHead(frac)                       — где сейчас воспроизведение
 */
(function () {
'use strict';
if (window.VSTimeline) return;

function create(o) {
    var el = o.el, canvas = o.canvas, ctx = canvas.getContext('2d');
    var st = { total: 0, before: null, after: null, progress: null, head: 0, floor: 0 };
    var queued = 0, dragging = false, ro = null;

    function color(name, fb) {
        var v = getComputedStyle(el).getPropertyValue(name);
        return (v && v.trim()) || fb;
    }
    function schedule() {
        if (queued) return;
        queued = requestAnimationFrame(function () { queued = 0; paint(); });
    }
    function fit() {
        var r = el.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
        var w = Math.max(2, Math.round(r.width * dpr)), h = Math.max(2, Math.round(r.height * dpr));
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
    }
    /* Устойчивый масштаб: 95-й процентиль тряски, а не максимум — один
       рывок на весь ролик иначе сплющил бы остальной график в полосу. */
    /* И пол масштаба в абсолютных единицах (st.floor — доля кадра, её даёт
       страница): без него ровный ролик, чья «тряска» — шум оценки в 0.1 px,
       растягивался на всю высоту и выглядел трясущимся (снимок 30.09). */
    function scaleOf(a) {
        var v = [];
        for (var i = 0; i < a.length; i++) if (a[i] != null && isFinite(a[i])) v.push(a[i]);
        var fl = st.floor || 1e-6;
        if (!v.length) return fl;
        v.sort(function (x, y) { return x - y; });
        return Math.max(fl, v[Math.min(v.length - 1, Math.floor(v.length * 0.95))] * 1.15);
    }
    /* Сжатие кадров в столбцы холста: максимум столбца — пик рывка не должен
       теряться между пикселями. */
    function bins(a, n, w) {
        var out = new Float32Array(w), seen = new Uint8Array(w);
        for (var i = 0; i < a.length && i < n; i++) {
            if (a[i] == null) continue;
            var x = Math.min(w - 1, Math.floor(i * w / n));
            if (!seen[x] || a[i] > out[x]) { out[x] = a[i]; seen[x] = 1; }
        }
        return { v: out, seen: seen };
    }
    function paint() {
        fit();
        var w = canvas.width, h = canvas.height, n = st.total || 0;
        ctx.clearRect(0, 0, w, h);
        var pad = Math.round(h * 0.12), base = h - pad, top = pad;
        var warn = color('--lg-warn', '#f59e0b'), good = color('--lg-success', '#22c55e');
        var acc = color('--lg-accent', '#7aa7ff'), mute = color('--lg-text-3', '#8894a8');
        // Базовая линия.
        ctx.fillStyle = mute; ctx.globalAlpha = 0.25;
        ctx.fillRect(0, base, w, Math.max(1, Math.round(h / 60)));
        ctx.globalAlpha = 1;
        if (n > 1 && st.before) {
            var s = scaleOf(st.before), b = bins(st.before, n, w);
            ctx.beginPath();
            ctx.moveTo(0, base);
            for (var x = 0; x < w; x++) {
                var y = b.seen[x] ? base - Math.min(1, b.v[x] / s) * (base - top) : base;
                ctx.lineTo(x + 0.5, y);
            }
            ctx.lineTo(w, base);
            ctx.closePath();
            ctx.globalAlpha = 0.55; ctx.fillStyle = warn; ctx.fill();
            ctx.globalAlpha = 1;
            if (st.after) {
                var a = bins(st.after, n, w);
                ctx.beginPath();
                var started = false;
                for (var x2 = 0; x2 < w; x2++) {
                    if (!a.seen[x2]) continue;
                    var y2 = base - Math.min(1, a.v[x2] / s) * (base - top);
                    if (!started) { ctx.moveTo(x2 + 0.5, y2); started = true; } else ctx.lineTo(x2 + 0.5, y2);
                }
                ctx.lineWidth = Math.max(1.25, h / 40);
                ctx.strokeStyle = good; ctx.lineJoin = 'round';
                ctx.stroke();
            }
        }
        // Докуда дошёл разбор: правее — приглушено.
        if (st.progress != null) {
            var px = Math.round(w * Math.max(0, Math.min(1, st.progress)));
            ctx.globalAlpha = 0.14; ctx.fillStyle = mute;
            ctx.fillRect(px, 0, w - px, h);
            ctx.globalAlpha = 1;
            ctx.fillStyle = acc;
            ctx.fillRect(Math.max(0, px - 1), 0, Math.max(2, Math.round(h / 22)), h);
        } else {
            var hx = Math.round(w * Math.max(0, Math.min(1, st.head)));
            var lw = Math.max(2, Math.round(h / 20));
            ctx.fillStyle = acc;
            ctx.fillRect(Math.max(0, Math.min(w - lw, hx - lw / 2)), 0, lw, h);
            ctx.beginPath();
            ctx.arc(Math.max(lw * 2, Math.min(w - lw * 2, hx)), lw * 2, lw * 2, 0, Math.PI * 2);
            ctx.fill();
        }
    }

    function fracOf(ev) {
        var r = el.getBoundingClientRect();
        // Время идёт слева направо и в арабском интерфейсе (полоса — dir="ltr").
        var x = (ev.clientX - r.left) / Math.max(1, r.width);
        return Math.max(0, Math.min(1, x));
    }
    function down(ev) {
        if (st.progress != null || ev.button > 0) return;
        dragging = true;
        try { el.setPointerCapture(ev.pointerId); } catch (_) {}
        if (o.onSeek) o.onSeek(fracOf(ev));
        ev.preventDefault();
    }
    function move(ev) { if (dragging && o.onSeek) o.onSeek(fracOf(ev)); }
    function up(ev) { dragging = false; try { el.releasePointerCapture(ev.pointerId); } catch (_) {} }
    el.addEventListener('pointerdown', down);
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
    if (typeof ResizeObserver !== 'undefined') { ro = new ResizeObserver(schedule); ro.observe(el); }
    try {
        var mq = window.matchMedia('(prefers-color-scheme: dark)');
        if (mq && mq.addEventListener) mq.addEventListener('change', schedule);
    } catch (_) {}

    return {
        setData: function (d) {
            if (d.total != null) st.total = d.total;
            if (d.floor != null) st.floor = d.floor;
            if ('before' in d) st.before = d.before;
            if ('after' in d) st.after = d.after;
            schedule();
        },
        setProgress: function (f) { st.progress = f; schedule(); },
        setHead: function (f) { st.head = f; schedule(); },
        repaint: schedule,
        destroy: function () {
            if (ro) { try { ro.disconnect(); } catch (_) {} }
            el.removeEventListener('pointerdown', down);
            el.removeEventListener('pointermove', move);
            el.removeEventListener('pointerup', up);
            el.removeEventListener('pointercancel', up);
        }
    };
}

window.VSTimeline = { create: create };
})();
